export const TABLE_PAGE_SIZES = [25, 50, 100, 250]
